"use strict";

exports.__esModule = true;
var nano_css_1 = require("nano-css");
var cssom_1 = require("nano-css/addon/cssom");
var vcssom_1 = require("nano-css/addon/vcssom");
var cssToTree_1 = require("nano-css/addon/vcssom/cssToTree");
var react_1 = require("react");
var nano = (0, nano_css_1.create)();
(0, cssom_1.addon)(nano);
(0, vcssom_1.addon)(nano);
var counter = 0;
var useCss = function useCss(css, prefix) {
  var className = (0, react_1.useMemo)(function () {
    return "".concat(prefix || 'rc-use-css', "__").concat(Date.now().toString(32), "-").concat(counter++);
  }, []);
  var sheet = (0, react_1.useMemo)(function () {
    return new nano.VSheet();
  }, []);
  (0, react_1.useEffect)(function () {
    var tree = {};
    (0, cssToTree_1.cssToTree)(tree, css, '.' + className, '');
    sheet.diff(tree);
    return function () {
      sheet.diff({});
    };
  }, [css]);
  return className;
};
exports["default"] = useCss;